export enum VariantSelectionMode {
  ALWAYS_PROMPT = "ALWAYS_PROMPT",
  DEFAULT_ON_PRESS = "DEFAULT_ON_PRESS",
}
